import React from 'react'
import { Button } from '@/components/ui/button'

interface RefineWrapperProps {
  children: React.ReactNode
  onSave?: () => void
  saveButtonText?: string
}

const RefineWrapper: React.FC<RefineWrapperProps> = ({
  children,
  onSave,
  saveButtonText = "Save Changes"
}) => {
  return (
    <div className="text-center">
      {children}
      
      {onSave && (
        <div className="flex justify-end mt-6">
          <Button
            onClick={onSave}
            className="px-6 py-2 bg-gray-800 hover:bg-gray-900 text-white"
          >
            {saveButtonText}
          </Button>
        </div>
      )}
    </div>
  )
}

export default RefineWrapper
